export default __webpack_public_path__ + "static/media/ic_bsc_circle.a6c52a7f.svg";